<template>
  <div class="container multi-card-container main-view">
    <div class="row">
      <div class="col-lg-12">
        <h1>{{$t('statistics_header')}}</h1>
      </div>
		<div class="col-lg-12 card-col overall-statistics">
			<div class="card-ct card-rounded-shadowed">

				<div class="row">
          <div v-for="depositType in depositTypesList.data.data" :key="depositType.type_name" class="col-lg-2 col-md-4 col-sm-6 col-12 item">
						<div class="icon-ct deposit-type-image">
              <img v-if="!depositType.image" :src="getImagePath(depositType.type_name)" :alt="depositType.title">
              <img v-else :src="depositType.image.path" :alt="depositType.title">
            </div>
						<div class="desc">
							<p>{{$t(depositType.type_name)}}</p>
							<h3>{{totals[depositType.type_name]}} <small>{{$t('amount_pieces')}}</small></h3>
						</div>
					</div>
				</div>
				<div class="row row-total">
					<div class="col-lg-12">
						<div class="bracket">
							<div></div><span class="a"></span><span class="b"></span><div></div>
						</div>
						<div class="total">
						<h3>{{getSum()}} <small>{{$t('amount_pieces')}}</small></h3>
						</div>
					</div>
				</div>
			</div>
		</div>
      <div class="col-lg-12 card-col">
        <div class="card-ct card-rounded-shadowed">
          <div class="row">
            <div class="col-lg-12">
              <div class="accordion accordion-table" id="recent-visits-table">
                <div class="table-header-row row">
                  <div class="col-md-1 indicator-arrow"></div>
                  <div class="col-md-4 col-6 place-col">{{$t('statistics_device')}}</div>
                  <div class="col-md-3 col-6 points-col">{{$t('achievements_points')}}</div>
                  <div class="col-md-4 amount-col">{{$t('statistics_recycled_amount')}}</div>
                </div>
                <div v-for="(stats, index) in deviceStatData" :key="'key' + index">
                  <div :id="'item' + index">
                    <a href="#" @click="setExpand($event, 'item' + index)"
                       :class="(expanded['item' + index] ? '' : 'collapsed ') + 'row toggle-row'"
                       data-toggle="collapse"
                       :data-target="'#collapse-item' + index"
                       aria-expanded="true">
                      <div class="col-md-1 indicator-arrow"><span></span></div>
                      <div class="col-md-4 col-6 place-col">{{ stats.name }}</div>
                      <div class="col-md-3 col-6 points-col">{{ stats.credits }} <small>{{ $t('achievements_points') }}</small></div>
                      <div class="col-md-4 amount-col">{{ stats.deposits }} <small>{{$t('amount_pieces')}}</small></div>
                    </a>
                  </div>
                  <collapse-transition :duration="350" easing="ease-in-out">
                    <div v-show="transitioned['item' + index]"
                         :id="'collapse-item' + index"
                         :class="(expanded['item' + index] ? 'show ' : '') + 'collapse'"
                         :aria-labelledby="'item' + index">
                      <div class="row justify-content-center pt-4">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                          <div class="doughnut-chart-ct py-4">
                            <h3 class="text-center">{{$t('statistics_total_deposit')}}</h3>
                            <div class="doughnut-chart">
                              <div class="total-amount-ct">
                                <div class="total-amount">
                                  <div class="kg">{{ stats.totalWeight }} <small>{{$t('amount_kg')}}</small></div>
                                  <div class="gab">{{ stats.deposits }} <small>{{$t('amount_pieces')}}</small></div>
                                </div>
                              </div>
                              <doughnut :data="stats.chartData" :width="100" :height="130"></doughnut>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </collapse-transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Doughnut from '../../../components/Charts/DoughnutChart';
import CollapseTransition from '@ivanv/vue-collapse-transition';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from "@/store/types";
import statuses from "@/store/statuses";
import forEach from 'lodash.foreach';

const DevicesTypes = VuexTypes.devices;

export default {
  components: {
    Doughnut,
    CollapseTransition
  },
  props: [
  ],
  data () {
    return {
      spinners: {
        contentIsLoading: true
      },
      totals: {
        Tetrapack: 0,
        Can: 0,
        PET: 0,
        Battery: 0,
      },
      deviceStatData: [],
      expanded: {},
      transitioned: {}
    }
  },
  mounted () {
    this.DEVICE_TOTALS();
  },
  created () {
    this.getChartData();
  },
  computed: {
    ...mapGetters('Devices', ['deviceStats', 'deviceTotals']),
    ...mapGetters('Translations', ['language']),
    ...mapGetters('DepositTypes', ['depositTypesList'])
  },
  watch: {
    deviceStats: {
      handler() {
        if (this.deviceStats.status === statuses.LOADED) {
          this.fillChartData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    deviceTotals: {
      handler() {
        if (this.deviceTotals.status === statuses.LOADED) {
          this.fillTotals();
        }
      },
      deep: true
    },
    language: function (val, oldVal) {
      this.fillChartData();
    },
  },
  methods: {
    ...mapActions('Devices', [
      DevicesTypes.DEVICE_STATS,
      DevicesTypes.DEVICE_TOTALS
    ]),
    fillTotals () {
      let data = this.deviceTotals.data.data;
      Object.keys(data).forEach((key) => {
        Vue.set(this.totals, data[key].type_name, data[key].DepositCount);
      });
    },
    getChartData () {
      this.spinners.contentIsLoading = true;
      this.DEVICE_STATS();
    },
    fillChartData() {
      const devices = [];

      forEach(this.deviceStats.data.data, (item, index) => {
        let deviceData = {
          name: item.name,
          credits: item.credit_value,
          deposits: item.deposits,
          totalWeight: 0,
          chartData: {
            labels: [],
            datasets: []
          }
        };
        let dataset = {
          data: [],
          backgroundColor: [],
          hoverBackgroundColor: [],
          borderColor: 'rgba(255,255,255,1)',
          hoverBorderColor: 'rgba(255,255,255,1)',
          borderWidth: 2,
        };

        forEach(item.type_stats, typeStats => {
          deviceData.chartData.labels.push(this.$t(typeStats.title));
          dataset.data.push(typeStats.count);
          dataset.backgroundColor.push(typeStats.color);
          dataset.hoverBackgroundColor.push(typeStats.color);
          deviceData.totalWeight += parseFloat(typeStats.weight);
        });

        // To fix float type decimal place inaccuracies (this will show 4 decimal places max)
        deviceData.totalWeight = Math.round(deviceData.totalWeight * 10000) / 10000;

        deviceData.chartData.datasets.push(dataset);
        devices.push(deviceData);
      });

      this.deviceStatData = devices;
    },
    setExpand (e, item) {
      e.preventDefault();
      if (!this.expanded[item]) {
        Vue.set(this.expanded, item, true);
        Vue.set(this.transitioned, item, true);
      } else {
        let that = this;
        Vue.set(this.transitioned, item, false);
        setTimeout(function () {
          Vue.set(that.expanded, item, false);
        }, 350);
      }
    },
    getImagePath(type) {    
      let path;  
      try {
        path = require(`@/assets/img/icons/bg/${type}.svg`);
      } catch (e) {
        path = '';
      }

      return path;
    },
    getSum () {
      let sum = 0;
      Object.keys(this.totals).forEach((key) => {
        sum += this.totals[key];
      });
      return sum;
    }
  }
}
</script>

<style scoped lang="scss">
/* Fix for collapse transition wrong height calculation resulting in jittery transition */
.doughnut-chart-ct {
  min-height: 540px;
}

.deposit-type-image {
  img {
    width: inherit;
    height: inherit;
    object-fit: contain;
  }
}

.container.multi-card-container {
  margin-bottom: 0;
}
</style>